// src/store/slices/requestLogSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import requestLogApi from 'api/requestLogApi';

export const fetchRequestLogs = createAsyncThunk(
  'requestLog/fetchAll',
  async ({ page = 1, pageSize = 20, search = '', request = ''  }, { rejectWithValue }) => {
    try {
      const res = await requestLogApi.getAll(page, pageSize, search, request);
      return res;
    } catch (e) {
      return rejectWithValue(e.response?.data?.detail || 'Failed to load request logs');
    }
  }
);

const requestLogSlice = createSlice({
  name: 'requestLog',
  initialState: {
    logs: [],
    pagination: { count: 0, page_size: 20 },
    isLoading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRequestLogs.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchRequestLogs.fulfilled, (state, action) => {
        state.isLoading = false;
        state.logs = action.payload.data || [];
        state.pagination = action.payload.pagination || { count: 0, page_size: 20 };
      })
      .addCase(fetchRequestLogs.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError } = requestLogSlice.actions;
export default requestLogSlice.reducer;